import React from 'react';

import { cn } from '~/lib/utils';
import type { ContentInterface } from '~/payload-types';

import LexicalRenderer from '../LexicalRenderer';

export const ContentBlock: React.FC<ContentInterface> = (props) => {
  const { columns } = props;

  const getColSpanClass = (size: string) => {
    switch (size) {
      case 'full':
        return 'lg:col-span-12';
      case 'half':
        return 'lg:col-span-6';
      case 'oneThird':
        return 'lg:col-span-4';
      case 'twoThirds':
        return 'lg:col-span-8';
      default:
        return 'lg:col-span-12';
    }
  };

  return (
    <div className="grid grid-cols-4 gap-3 lg:grid-cols-12">
      {columns &&
        columns.length > 0 &&
        columns.map((col, index) => {
          const { richText, size } = col;

          return (
            <div
              className={cn(`col-span-4 ${getColSpanClass(size!)}`, {
                'md:col-span-2': size !== 'full',
              })}
              key={index}
            >
              {richText && <LexicalRenderer data={richText} />}
            </div>
          );
        })}
    </div>
  );
};
